// extracted by mini-css-extract-plugin
export default {"confirmation-modal":"components-settings-central-mapping-modals-modal-confirmation-delete-category-module__confirmation-modal"};